import { Http } from "./http/Http";
import {ServiceBase} from "./ServiceBase"


const DefaultHttp = new Http();
const Https = { Http, DefaultHttp };

export {
    DefaultHttp,
    Https,
    ServiceBase
};

const Framework = {
    DefaultHttp,
    Https,
    ServiceBase
};
export default Framework;

declare global {
    interface Window {
        ff: typeof Framework;
        recordInterval: NodeJS.Timeout | null;
    }
}
window.ff = window.ff || Framework;
